import React, { useState, useEffect } from "react";
import './../../App.css';
import Container from 'react-bootstrap/Container';
import FormEditImageBanniere from "./formEditImageBanniere"
import MenuAdmin from './../menu/menuAdmin.jsx';
import AuthService from "../../services/auth.service";

export function ModificationBanniere() {
    const currentUser = AuthService.getCurrentUser();
    if (currentUser == null) {
        window.open("./login", "_self");
    }

    const [listImages, setListImages] = useState([]);

    useEffect(() => {
        fetch('/lineup/api/image/all')
            .then(response => {
                response.json().then(data => {
                    //On trie les images par selon la position
                    data.sort((a, b) => a.position - b.position);
                    setListImages(data)
                }).catch(err => {
                    console.log("Erreur lors de la recupération des données");
                    console.log(err)
                })
            }).catch(err => {
                console.log("Impossible d'accéder à l'api");
                console.log(err)
            });
    }, []);

    return (
        <div>
            <header className="App-header">
                <div className="bg-black" >
                    <MenuAdmin></MenuAdmin>
                </div>
            </header>
            <div>
                <Container>
                    <div id="alertMessage"></div>
                    <div className="row dashboardBanniere">
                        {listImages.map(function (img, index) {
                            return (
                                <div key={index} className="col-6 col-md-4 col-lg-4">
                                    <FormEditImageBanniere key={index} img={img}></FormEditImageBanniere>
                                </div>
                            );
                        })
                        }
                    </div>
                </Container>
            </div>
        </div>
    );
}
export default ModificationBanniere;